module.exports = __webpack_public_path__ + "img/universkin-serum-p-active-icon.606d4db8.svg";